
/**
* @feat < 公用常量 >
快速引入
import {IMG_HOST} from '@/CONSTANT/common'
*/
export const GET_DATA_STATUS = {
  pend: "pend",
  loading: "loading",
  errored: "errored",
  succeed: "succeed",
};


// 图片域名
export const IMG_HOST = 'http://api.youyuesp.com'

